import { useState } from "react";
import AlertBox from "../../components/AlertBox";
import Box from "../../components/Box";
import MainLayout from "../../components/layouts/MainLayout";
import { parseToIndoNumber } from "../../tools/numerictools";
import { useReportFtthProject } from "../../utils/customer/CustomerReqReprotUtil";

export default function ReportCustomerStatusFtth() {
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });

  const [formFilter, setFormFilter] = useState({ year: "2024" });
  const [filter, setFilter] = useState({ year: "2024", page: 1, page_size: 10 });

  const { projects, meta, loading, errorMsg } = useReportFtthProject({ filter });

  function applyFilter() {
    let form_filter = {
      ...filter,
      ...formFilter,
      page: 1,
    };
    setFilter(form_filter);
  }

  const resetFilter = () => {
    setFormFilter({
      year: "2024",
    });
    setFilter({
      year: "2024",
      page: 1,
      page_size: 10,
    });
  };

  return (
    <MainLayout resource_key="manage-customer">
      <div className="container-fluid">
        <h1 className="h3 mb-4 text-gray-800">Laporan Project FTTH</h1>
        <Box title="Laporan Project FTTH" loading={loading}>
          <div className="row">
            <div className="col-12 col-md-2">
              <div className="form-group">
                <label>Tahun</label>
                <select
                  value={formFilter.year}
                  className="form-control"
                  onChange={(event) => setFormFilter({ ...formFilter, year: event.target.value })}
                >
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                </select>
              </div>
            </div>
            <div className="col-auto">
              <button
                className="btn btn-primary"
                onClick={() => applyFilter()}
                style={{ marginTop: "32px" }}
              >
                Filter
              </button>
              <button
                className="btn btn-default"
                onClick={() => resetFilter()}
                style={{ marginTop: "32px" }}
              >
                Reset
              </button>
            </div>
          </div>
          {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}
          <AlertBox {...alert} setAlert={setAlert} />
          <div style={{ overflowX: "auto" }}>
            <table className="table table-bordered table-striped table-hover">
              <thead>
                <tr>
                  <th>Project</th>
                  <th className="text-center" style={{ width: "100px" }}>
                    Home Pass
                  </th>
                  <th className="text-center" style={{ width: "100px" }}>
                    Aktif
                  </th>
                  <th className="text-center" style={{ width: "100px" }}>
                    CSR
                  </th>
                  <th className="text-center" style={{ width: "100px" }}>
                    Total Pelanggan
                  </th>
                  <th className="text-center" style={{ width: "100px" }}>
                    Aktif %
                  </th>
                  <th className="text-center" style={{ width: "100px" }}>
                    Isolir/Berhenti
                  </th>
                  <th className="text-center" style={{ width: "100px" }}>
                    Isolir/Berhenti %
                  </th>
                </tr>
              </thead>
              <tbody>
                {projects.map((project, index) => (
                  <tr key={index}>
                    <td>{project.project || "-"}</td>
                    <td className="text-right">{parseToIndoNumber(project.home_pass)}</td>
                    <td className="text-right">{parseToIndoNumber(project.active_customers)}</td>
                    <td className="text-right">{parseToIndoNumber(project.csr_free)}</td>
                    <td className="text-right">{parseToIndoNumber(project.total_customers)}</td>
                    <td className="text-right">{project.active_percentage}</td>
                    <td className="text-right">
                      {parseToIndoNumber(project.disconnected_customers)}
                    </td>
                    <td className="text-right">{project.disconnected_percentage}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td className="text-right">
                    <b>Total</b>
                  </td>
                  <td className="text-right font-weight-bold">
                    {parseToIndoNumber(meta?.total_home_pass || 0)}
                  </td>
                  <td className="text-right font-weight-bold">
                    {parseToIndoNumber(meta?.total_active_customers || 0)}
                  </td>
                  <td className="text-right font-weight-bold">
                    {parseToIndoNumber(meta?.total_csr_free || 0)}
                  </td>
                  <td className="text-right font-weight-bold">
                    {parseToIndoNumber(meta?.total_customers || 0)}
                  </td>
                  <td className="text-right font-weight-bold">
                    {meta?.average_active_percentage || 0}
                  </td>
                  <td className="text-right font-weight-bold">
                    {parseToIndoNumber(meta?.total_disconnected_customers || 0)}
                  </td>
                  <td className="text-right font-weight-bold">
                    {meta?.average_disconnected_percentage || 0}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </Box>
      </div>
    </MainLayout>
  );
}
